export default {
  title: 'Unisciti a {{name}}!',
  default_program_name: 'Club Premi',
  benefits: {
    earn_points: 'Guadagna punti ad ogni ordine',
    get_deals: 'Ricevi sconti esclusivi',
    redeem_points: 'Riscatta punti per cibo gratuito',
  },
  terms: 'Registrandoti, riceverai offerte via email e SMS dal nostro&nbsp;',
  buttons: {
    log_in: 'Accedi',
    sign_up: 'Registrati',
  },
  labels: {
    already_have_account: 'Hai già un account?',
  },
  signup_note:
    'Registrandoti, riceverai offerte via email e SMS dal nostro <0>ristorante</0> e da <1>FoodAmigos</1>, il nostro partner tecnologico. Accetti i nostri <2>Termini della piattaforma</2> e la <3>Privacy Policy</3>.',
};
